import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  max-height: 255px;
  overflow-y: auto;
`;
